module.exports = __webpack_public_path__ + "static/media/a1c-dolce.127b8c78.png";